import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import dayjs from 'dayjs';
import { ordinal_suffix_of } from '../../../../SortableList';
import { DraggableItemWrapper } from './CandidateScheduleDateSelector.styles';
import moveIcon from '../../../../assets/images/icons/moveIcon.png';

const SelectedDateItem = ({ date, index, isOrdinal, singleDateChoice, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: date.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    if (!singleDateChoice) {
      onRemove(date.id);
    }
  };

  const itemsNumbered = isOrdinal ? ordinal_suffix_of((date.preference || index) + 1) : (date.preferences || index) + 1;

  return (
    <DraggableItemWrapper
      ref={setNodeRef}
      style={style}
      backgroundColor="rgb(64, 64, 64)"
      isClickable={!singleDateChoice}
      onClick={handleRemove}
    >
      <div className="date-content">
        {!singleDateChoice && <div className="ordinal-number">{itemsNumbered}:</div>}

        <div className="date-info">
          <div className="date-display">
            <div className="mobile_display">{dayjs(date.DateOfInterview).format('ddd, MMM DD, YYYY')}</div>
            <div className="browser_display">{dayjs(date.DateOfInterview).format('ddd, MMMM DD, YYYY')}</div>
          </div>
          {date.Label && <div className="date-label">{date.Label}</div>}
        </div>

        {!singleDateChoice && (
          <div className="drag-handle" {...attributes} {...listeners} onClick={(e) => e.stopPropagation()}>
            <img className="move-icon" src={moveIcon} alt="Drag to reorder" />
          </div>
        )}
      </div>
    </DraggableItemWrapper>
  );
};

export default SelectedDateItem;
